<template>
  <section class="table_box all_orders">
    <div class="container large flx">
      <div class="table_head flx">
        <span class="page_title">Все заказы
          <p v-if="pagination.from">Результат: {{ pagination.from }} - {{ pagination.to }} из {{ pagination.total }}</p>
        </span>
        <div class="flx" v-if="order_counters">
          <span class="item grey">Возвратов: <span>{{ order_counters.returned }}</span></span>
          <span class="item green">Завершенные: <span>{{ order_counters.completed }}</span></span>
          <span class="item red">Лежат на складе: <span>{{ order_counters.lies_warehouse }}</span></span>
        </div>
      </div>
      <div class="wrap_btn flx">
        <div class="wrap_action long active flx">
          <div class="flx">
            <span class="quantity" v-if="selected">Отмечено: {{ selected.length }}</span>
            <span class="reset_wrap cursor-pointer" v-if="selected && selected.length > 0"
                  @click="setSelectedOrders([])"><span class="close"> </span> <span class="red">Сбросить</span></span>
          </div>
          <div class="actions_cont export">
            <div class="btn actions_btn empty mobile_v" :class="{active: show_orders_actions}" data-id="actions_box"
                 @click="show_orders_actions = !show_orders_actions">
              <span>Действия</span>
              <svg width="9" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L4 4L7 1" stroke="#F5A32A" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round"/>
              </svg>
            </div>
            <div class="actions_box open_box flx" :class="{active: show_orders_actions}" data-id="actions_box">
              <p class="mobile_v">Действия с заказами:</p>
              <div class="btn empty" v-if="selected && selected.length > 0" @click="setShowChangeOrdersStatus(true)">
                Смена статуса
              </div>
              <router-link :to="{ name: 'OrderItemList',query: {ids: selected_orders}}" target="_blank"
                           class="btn empty">Список
              </router-link>
            </div>
          </div>
        </div>
        <span class="point"></span>
        <div class="flx">
          <div class="btn actions_btn empty" data-id="filters_box" :class="{active: show_order_filters}"
               @click="toggleOrderFilters">
            <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.3333 1H1L6.33333 7.30667V11.6667L9 13V7.30667L14.3333 1Z" stroke="#F5A32A"
                    stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span>Фильтры</span>
            <span class="counter_filters" v-if="count_order_filters > 0">{{ count_order_filters }}</span>
          </div>
          <a @click="createNewOrder()" class="btn create">Создать заказ</a>
        </div>
      </div>
      <order-filters></order-filters>
    </div>
    <div class="container has_table">
      <div class="table_body table_all_orders">
        <div class="top_table flx">
          <div class="search_box flx">
            <div class="choose_seller flx">
              <p>Продавец:</p>
              <user-select
                  class="mini-select"
                  style="min-width: 225px;margin-right: 10px"
                  :default-id="null"
                  default-name="Все"
                  :items="dropshippers"
                  @search="fetchDropshippers"
                  @select="selectDropshipper"
                  @active-input="fetchDropshippers"
                  :is-filter="true"
              ></user-select>
            </div>
            <div class="wrap_search flx">
              <button type="submit"></button>
              <input type="text" placeholder="Поиск..." v-model="search" id="search">
              <ul class="search_list_box">
                <li class="item"><a href="#">item</a></li>
                <li class="item"><a href="#">item</a></li>
                <li class="item"><a href="#">item</a></li>
                <li class="item"><a href="#">item</a></li>
                <li class="item"><a href="#">item</a></li>
              </ul>
            </div>
          </div>
          <div class="pagination flx">
            <div class="flx">
              <p class="desctop_v">Строк:</p>
              <div class="select" id="sellers">
                <brew-select
                    class="select-pagination select-orders-per_page select-full"
                    style="margin-left:10px;width: 100px"
                    v-model="perPage"
                    :clearable="false"
                    :options="page_sizes"
                >
                </brew-select>
              </div>
            </div>
            <paginate
                style="margin-left: 20px"
                class="flx"
                v-model="page"
                :page-count="pagination.last_page"
                :page-range="3"
                :margin-pages="2"
                :prev-text="'<'"
                :next-text="'>'"
            >
            </paginate>
          </div>
        </div>
        <div class="bot_table">
          <headline :headers="headers" :selected-all.sync="isSelectAll" :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"></headline>
          <div class="row_list">
            <div
                v-for="order in orders"
                :key="'order-' + order.id"
                :class="[{ checked: selected && selected.indexOf(order.id) !== -1 }, orderClass(order)]"
                class="row flx"
                :rel="order.id"
                @click.self.prevent="routeTo(order.id)"
            >
              <label class="custom-checkbox">
                <input type="checkbox" name="check" v-model="selected" :value="order.id">
                <span></span>
              </label>
              <div class="order_info flx" @click="routeTo(order.id)">
                <span>
                  <router-link :to="'/dashboard/orders/orders/'+order.id">{{ order.id }}</router-link>
                  <a
                      v-if="order.file"
                      @click.stop
                      target="_blank"
                      :href="order.file">&nbsp;
                  <svg style="display: inline" width="12" height="13" viewBox="0 0 12 13" fill="none"
                       xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.32472 0.701778C6.57345 0.439798 6.98453 0.431889 7.24288 0.684114C7.50123 0.936338 7.50903 1.35318 7.2603 1.61516L6.54181 2.37145C6.1048 2.83127 5.51215 3.45456 4.88962 4.10839C3.66359 5.39607 2.31601 6.80819 1.81756 7.31869C1.20153 8.08118 1.01372 9.51529 1.93375 10.4558C2.86343 11.4063 4.54605 11.4444 5.51304 10.4558C6.51816 9.42832 7.51489 8.37467 8.35864 7.4773C8.55514 7.2683 8.74385 7.06725 8.92266 6.87673C9.49971 6.26191 9.97381 5.75679 10.2751 5.44826C10.4349 5.26441 10.6306 4.93126 10.686 4.56266C10.7372 4.22262 10.6762 3.83258 10.2872 3.43496C9.88022 3.01889 9.50647 2.94982 9.21361 2.98115C8.89636 3.01509 8.61914 3.17571 8.47045 3.30687L3.74373 8.27696C3.72186 8.31221 3.69124 8.38056 3.6875 8.45711C3.68558 8.4965 3.69053 8.5389 3.70844 8.586C3.72632 8.63299 3.76309 8.70041 3.84339 8.7825C3.9029 8.84334 3.97376 8.86684 4.07745 8.85485C4.13242 8.8485 4.187 8.83203 4.23242 8.81104C4.27154 8.79295 4.28895 8.77886 4.28895 8.77886L7.55912 5.43584C7.81168 5.17766 8.22282 5.17597 8.47744 5.43207C8.73205 5.68818 8.73372 6.1051 8.48116 6.36328L5.20744 9.70994C4.97496 9.94759 4.60435 10.1194 4.22459 10.1633C3.81768 10.2104 3.32018 10.1177 2.92135 9.70994C2.51826 9.29787 2.36907 8.82782 2.39038 8.39192C2.4103 7.98444 2.57609 7.64847 2.7373 7.44247C2.75029 7.42588 2.76405 7.40993 2.77855 7.39469L7.55272 2.37471C7.56274 2.36417 7.57311 2.35398 7.5838 2.34414C7.89364 2.05907 8.42725 1.74103 9.07735 1.67148C9.76205 1.59823 10.525 1.80804 11.2093 2.50752C11.9115 3.22546 12.0778 4.04393 11.9699 4.76133C11.8673 5.44317 11.5237 6.01075 11.2305 6.34053C11.2236 6.34829 11.2165 6.35587 11.2093 6.36328C10.919 6.66 10.4541 7.15529 9.8727 7.77476L9.87243 7.77505C9.69181 7.96748 9.49995 8.17189 9.29859 8.38606C8.45337 9.28499 7.4495 10.3462 6.43508 11.3833C4.94678 12.9047 2.43599 12.8394 1.01169 11.3833C-0.496318 9.84161 -0.116372 7.60374 0.839418 6.45176C0.850832 6.438 0.862798 6.42472 0.875284 6.41196C1.34879 5.9279 2.70893 4.50272 3.95531 3.19367C4.57748 2.54021 5.16985 1.91723 5.60668 1.45759L6.32472 0.701778Z" fill="#ADB8C6"/>
                  </svg>
                  </a>
                </span>
                <span>{{ order.date }}</span>
                <small class="order-list-time">{{ order.time }}</small>
              </div>
              <div class="declaration_info flx">
                <order-ttn :order="order"></order-ttn>
                <span class="grey" v-if="order.sender">Отпр: {{
                    order.sender.last_name
                  }} {{ order.sender.first_name | firstLetter }} {{ order.sender.middle_name | firstLetter }}</span>
                <div style="color: orangered" v-if="order.delivery_id === 3">Своя ТТН</div>
              </div>
              <div class="delivery_info" @click="routeTo(order.id)">
                <span v-if="order.client_data">
                  <span class="w-100">{{ order.client_data.last_name }} {{ order.client_data.first_name | firstLetter }} {{
                      order.client_data.middle_name | firstLetter
                    }}</span>
                  <span>{{ order.client_data.phone | removeCodeCountry }}</span>
                </span>
                <span v-if="order.delivery_method_id === 1 && order.client_data.city && order.client_data.branch">
                  <b v-if="order.client_data.city.name">{{
                      order.client_data.is_ua ? order.client_data.city.name_ua : order.client_data.city.name
                    }}</b>
                  <span v-if="order.delivery_method_id === 1 && order.client_data.branch.number"> (склад {{
                      order.client_data.branch.number
                    }})</span>
                  <span v-else-if="order.delivery_method_id === 1 && order.client_data.branch.name"> ({{
                      order.client_data.is_ua ? order.client_data.branch.name_ua : order.client_data.branch.name
                    }})</span>
                  <span v-if="order.delivery_method_id === 2 && order.client_data.address"></span>
                </span>
                <span v-if="order.delivery_method_id === 2 && order.client_data && order.client_data.city">
                  <b v-if="order.client_data.city.name">{{
                      order.client_data.is_ua ? order.client_data.city.name_ua : order.client_data.city.name
                    }}</b>
                  <span v-if="order.client_data.address && order.client_data.address.street">
                     Адрес: {{
                      order.client_data.address.street ? order.client_data.address.street.name : ''
                    }} {{ order.client_data.address.house ? order.client_data.address.house : 'н-д' }} {{ order.client_data.address.appt }}
                  </span>
              </span>
              </div>
              <div class="status_info">
                <span class="status" :class="getOrderStatusColor(order)">{{ order.status_name }}</span>
              </div>
              <div class="payment_info flx">
                <span class="pay_count" v-if="order.total_final !== order.total_discount">{{
                    order.total_discount | asPriceNoCurrency
                  }}/{{ order.total_final | asPrice }}</span>
                <span class="pay_count" v-else>{{ order.total_drop | asPrice }}</span>
                <span class="grey" v-if="order.delivery_id === 2"> Самовывоз</span>
                <span class="grey" v-else>{{ order.pay_type_name }}</span>
                <a v-if="order.check" target="_blank" :href="'https://check.checkbox.ua/'+order.check">Смотреть чек</a>
              </div>
              <div class="delivery_status_info">
                <span class="status" :class="getOrderDeliveryColor(order)">{{ order.delivery_status_name }}</span>
              </div>
              <div class="items_info flx">
                <span class="open_pop" @click="setShowOrderProductsModal([true, order])">
                  <span v-for="(product, index ) in order.products"
                        :key="'order-product-'+product.product_color_size_id">
                    <span v-if="index <=1">
                      <span v-if="index>0"> + </span>
                      {{ product.size }} · {{ (product.short_name || product.name) }} · {{ product.color }}
                    </span>
                  </span>
                  <span v-if="order.products.length > 2">...</span>
                  <div v-if="order.seller_comment" style="color: red">{{ order.seller_comment }}</div>
                </span>
              </div>
              <div class="cross close open_pop" @click="delOrder(order)"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <change-order-status-modal></change-order-status-modal>
    <order-delete-modal></order-delete-modal>
  </section>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import _ from 'lodash'
import { dates } from '../../../helpers/dates'
import { phones } from '../../../helpers/phones'
import OrderFilters from './OrderFilters'
import helper from '@/helpers/helper'
import OrderTtn from './OrderTtn'
import { strings } from '../../../helpers/strings'
import { prices } from '../../../helpers/prices'
import ChangeOrderStatusModal from '../../Modals/ChangeOrderStatusModal'
import OrderDeleteModal from '../../Modals/OrderDeleteModal'
import Headline from '../../Helpers/Headline'
import router from '../../../router'
import UserSelect from '../../Helpers/UserSelect'

export default {
  name: 'AllOrders',
  mixins: [
    dates,
    phones,
    strings,
    prices
  ],
  components: {
    UserSelect,
    OrderFilters,
    OrderTtn,
    ChangeOrderStatusModal,
    OrderDeleteModal,
    Headline
  },
  data () {
    return {
      page_sizes: [10, 50, 100, 1000, 10000],
      timer: null,
      show_orders_actions: false,
      headers: [
        {
          title: '',
          check_all: true,
          class: 'custom-checkbox'
        },
        {
          title: 'ЗАКАЗ',
          title_class: 'title',
          sortable: true,
          class: 'order_info',
          value: 'id'
        },
        {
          title: 'Декларация',
          class: 'declaration_info'
        },
        {
          title: 'Клиент・Доставка',
          class: 'delivery_info'
        },
        {
          title: 'СТАТУС',
          class: 'status_info'
        },
        {
          title: 'Оплата',
          sortable: true,
          class: 'payment_info',
          value: 'total_final'
        },
        {
          title: 'Состояние доставки',
          class: 'delivery_status_info'
        },
        {
          title: 'Товары',
          class: 'items_info'
        }
      ]
    }
  },
  computed: {
    ...mapState('orders', [
      'orders',
      'total_sum',
      'completed_sum',
      'selected_orders',
      'pagination',
      'show_order_filters',
      'filters',
      'show_change_orders_status',
      'show_order_delete_modal',
      'order_counters',
      'order'
    ]),
    ...mapState('users', ['dropshippers']),
    ...mapGetters('orders', ['count_order_filters']),
    ...mapGetters('users', ['getDefaultDropshipperFilters']),
    selected: {
      get () {
        return this.selected_orders
      },
      set (val) {
        this.setSelectedOrders(val)
      }
    },
    page: {
      get () {
        return this.filters.page
      },
      set (value) {
        this.setPage(value)
        this.getOrdersListV1()
      }
    },
    perPage: {
      get () {
        return this.filters.per_page
      },
      set (perPage) {
        this.setPerPage(perPage)
        this.setPage(1)
        this.getOrdersListV1()
      }
    },
    search: {
      get () {
        return this.filters.search
      },
      set (value) {
        clearTimeout(this.timer)
        this.setSearch(value)
        this.timer = setTimeout(() => {
          this.setPage(1)
          this.getOrdersListV1()
        }, 500)
      }
    },
    sortBy: {
      get () {
        return this.filters.order_by
      },
      set (val) {
        this.setOrderBy(val)
      }
    },
    sortDesc: {
      get () {
        return this.filters.order_direction
      },
      set (val) {
        this.setOrderDirection(val)
      }
    },
    isSelectAll: {
      get () {
        if (this.orders.length === 0) {
          return false
        }
        return this.selected && this.selected.length === this.orders.length && this.selected.length > 0
      },
      set (value) {
        if (value) {
          this.selected = _.map(this.orders, 'id')
        } else {
          this.selected = []
        }
      }
    }
  },
  watch: {
    sortBy () {
      this.getOrdersListV1()
    },
    sortDesc () {
      this.getOrdersListV1()
    }
  },
  methods: {
    ...mapActions('orders', ['getOrdersListV1', 'toggleOrderFilters', 'deleteOrder', 'getOrderCounters', 'createOrder']),
    ...mapMutations('orders', [
      'clearFilters',
      'setOrderBy',
      'setOrderDirection',
      'setSelectedOrders',
      'setPage',
      'setPerPage',
      'setPagination',
      'setSearch',
      'setShowOrderProductsModal',
      'setShowChangeOrdersStatus',
      'setShowOrderDeleteModal',
      'setOrderOnDelete',
      'clearOrder'
    ]),
    ...mapActions('users', ['getDropshippers']),
    ...mapMutations('users', {
      setDropshipperFilters: 'setDropshipperFilters',
      searchDrop: 'setSearch'
    }),
    orderClass (order) {
      return helper.getOrderClassByStatus(order.status) + ' ' + helper.getOrderClassByDeliveryStatus(order.delivery_status)
    },
    getOrderStatusColor (order) {
      return helper.getOrderStatusColor(order.status)
    },
    getOrderDeliveryColor (order) {
      return helper.getOrderDeliveryColor(order.delivery_status)
    },
    delOrder (order) {
      this.setOrderOnDelete(order)
      this.setShowOrderDeleteModal(true)
    },
    routeTo (orderId) {
      router.push({ name: 'Order', params: { id: orderId } })
    },
    createNewOrder () {
      this.clearOrder()
      this.createOrder()
    },
    fetchDropshippers (search) {
      this.searchDrop(search)
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.getDropshippers()
      }, 500)
    },
    selectDropshipper (data) {
      this.filters.dropshipper_id = data.id
      this.getOrdersListV1()
    }
  },
  created () {
    // this.clearFilters()
    this.clearOrder()
    this.getOrdersListV1()
    this.getOrderCounters()
    const dropshipperFilters = this.getDefaultDropshipperFilters
    dropshipperFilters.per_page = 99999
    this.setDropshipperFilters(dropshipperFilters)
    this.$nextTick(() => {
      this.getDropshippers()
    })
  }
}
</script>
